// extracted by mini-css-extract-plugin
export default {"icon":"Icon_icon__LUprd","sm":"Icon_sm__KYDUL","md":"Icon_md__9TfuA","lg":"Icon_lg__+LkEN"};